import axios from "axios";
const jsonConfig = require("../../Config.json");

const accessReport = async (payload) => {
    try {
        const resp = await axios.post(
            jsonConfig.apiUrl + "activityLogs",
             payload,
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            });
            let decompressedObject;
            if (resp?.data && resp?.data?.compressedbase64string) {
                // Lazy load fflate only when needed
                const { unzlibSync, strFromU8 } = await import("fflate");
                
                const strData = atob(resp.data.compressedbase64string);
                const charData = strData.split("").map((x) => {
                    return x.charCodeAt(0);
                });
                const binData = new Uint8Array(charData);
                let apiDataUnCompressed = unzlibSync(binData);
                let apiDataUnCompressedString = strFromU8(apiDataUnCompressed);
                decompressedObject = JSON.parse(apiDataUnCompressedString);
            }
            return Promise.resolve(decompressedObject);
    }
    catch (err) {
        return Promise.reject(err);
    }
}

export default accessReport;